import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { combineLatest, map, take } from 'rxjs';
import { authPersist, AuthRepository } from '../auth/state/auth.repository';

export const authGuard: CanActivateFn = (route, state) => {
  const _router = inject(Router);
  const _authRepository = inject(AuthRepository);

  return combineLatest([
    _authRepository.token$,
    authPersist.initialized$,
  ]).pipe(
    take(1),
    map(([data]) => {
      if (data?.accessToken === null) {
        _router.navigate(['/public/login']);
        return false;
      }
      return true;
    })
  );
};
